import { render, staticRenderFns } from "./MyQrCode.vue?vue&type=template&id=1364663d&scoped=true"
import script from "./MyQrCode.vue?vue&type=script&lang=js"
export * from "./MyQrCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1364663d",
  null
  
)

export default component.exports